/** @format */

import React from "react";
import { useSelector } from "react-redux";
import Logo from "./Logo";
import NavLinks from "./NavLinks";

const Sidebar = () => {
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);

  return (
    <aside
      id="logo-sidebar"
      className={`sticky h-screen top-0 w-60 pt-10 transition-transform ${
        isSidebarOpen ? "block" : "hidden"
      } sm:translate-x-0  lg:block bg-[#FCFCFC]`}
      aria-label="Sidebar"
    >
      <div className="ml-2 px-2 pb-10 lg:px-5 lg:pl-3">
        <Logo />
      </div>
      <NavLinks />
    </aside>
  );
};

export default Sidebar;
